export default __webpack_public_path__ + "static/media/check-out-review.56e863ca.png";